"use strict";

exports.__esModule = true;
exports.AvatarBase = AvatarBase;
var React = _interopRequireWildcard(require("react"));
var _AvatarBaseSt = require("./Avatar.base.st.css");
var _AnonymousIcon = require("./AnonymousIcon");
var _utils = require("./utils");
var _types = require("./types");
var _image = require("@wix/image");
var _constants = require("./constants");
var _utils2 = require("../WowImage/utils");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/Avatar/Avatar.base.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function AvatarBase({
  name,
  src,
  onLoad,
  className,
  lettersLimit = 1,
  textType = _constants.AVATAR_TEXT_TYPE.initials,
  ...rest
}) {
  const prevSrc = React.useRef(src);
  const _React$useState = React.useState(_types.ImageLoadStates.LOADING),
    imageStatus = _React$useState[0],
    setImageStatus = _React$useState[1];
  const isImageLoaded = imageStatus === _types.ImageLoadStates.READY;
  const _onLoad = event => {
    setImageStatus(_types.ImageLoadStates.READY);
    onLoad && onLoad(event);
  };
  const _onError = () => {
    setImageStatus(_types.ImageLoadStates.FAILURE);
  };
  function getContentData() {
    const isFailedLoadingImage = imageStatus === _types.ImageLoadStates.FAILURE;
    const isSrcChanged = prevSrc.current !== src;
    const shouldShowImage = src && (!isFailedLoadingImage || isSrcChanged);
    if (shouldShowImage) {
      if (isSrcChanged) {
        prevSrc.current = src;
        if (isFailedLoadingImage) {
          setImageStatus(_types.ImageLoadStates.LOADING);
        }
      }
      return {
        Component: /*#__PURE__*/React.createElement(ImageAvatar, {
          lettersLimit: lettersLimit,
          name: name,
          onImgLoadError: _onError,
          onLoad: _onLoad,
          imageLoaded: isImageLoaded,
          src: src,
          textType: textType,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 51,
            columnNumber: 11
          }
        }),
        type: 'image'
      };
    }
    if (name) {
      return {
        Component: /*#__PURE__*/React.createElement(TextAvatar, {
          name: name,
          lettersLimit: lettersLimit,
          textType: textType,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 68,
            columnNumber: 11
          }
        }),
        type: 'text'
      };
    }
    return {
      Component: /*#__PURE__*/React.createElement(AnonymousAvatar, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 78,
          columnNumber: 25
        }
      }),
      type: 'placeholder'
    };
  }
  const _getContentData = getContentData(),
    Component = _getContentData.Component,
    type = _getContentData.type;
  return /*#__PURE__*/React.createElement("div", {
    "data-content-type": type // for testing
    ,
    "data-img-loaded": isImageLoaded // for testing
    ,
    "data-hook": rest['data-hook'],
    title: name,
    "aria-label": name,
    className: (0, _AvatarBaseSt.st)(_AvatarBaseSt.classes.root, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 5
    }
  }, Component);
}
function ImageAvatar({
  src,
  name,
  lettersLimit,
  textType,
  onImgLoadError,
  onLoad,
  imageLoaded
}) {
  const imageSrc = (0, _utils2.extractWixMediaId)(src) || src;
  React.useEffect(() => {
    (0, _image.initCustomElement)();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !imageLoaded && /*#__PURE__*/React.createElement("div", {
    className: _AvatarBaseSt.classes.loadingWrapper,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 9
    }
  }, name ? /*#__PURE__*/React.createElement(TextAvatar, {
    name: name,
    lettersLimit: lettersLimit,
    textType: textType,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 13
    }
  }) : /*#__PURE__*/React.createElement(AnonymousAvatar, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(_image.Image, {
    height: undefined,
    width: undefined,
    className: (0, _AvatarBaseSt.st)(_AvatarBaseSt.classes.image, _AvatarBaseSt.classes.content),
    alt: name,
    uri: imageSrc,
    name: imageSrc,
    onLoad: onLoad,
    onError: onImgLoadError,
    displayMode: "fill",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 7
    }
  }));
}
function TextAvatar({
  name,
  lettersLimit = 1,
  textType = _constants.AVATAR_TEXT_TYPE.initials
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: _AvatarBaseSt.classes.content,
    "data-hook": "text-container",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 154,
      columnNumber: 5
    }
  }, textType === _constants.AVATAR_TEXT_TYPE.initials ? (0, _utils.nameToInitials)(name, lettersLimit) : name);
}
function AnonymousAvatar() {
  return /*#__PURE__*/React.createElement(_AnonymousIcon.AnonymousIcon, {
    className: (0, _AvatarBaseSt.st)(_AvatarBaseSt.classes.content, _AvatarBaseSt.classes.anonymous),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163,
      columnNumber: 10
    }
  });
}
//# sourceMappingURL=Avatar.base.js.map